/**
 * JS file that has functions for translating qr code urls and telling the consumer what they are for.
 */

/**
 * Function for translating QR Codes into component objects that are meaningful to the library.
 * @param {String} qrCode 
 * @returns {Object} translation object constructed from the result.
 */
function translateQRCode(qrCode)
{
    
    const tokens = qrCode.split('/').filter((t) => { return !t.includes('links') && !t.includes('https'); });

    const result = 
    {
        untranslatedCode: qrCode,
        code: qrCode,
        type: 'Sample',
        actionTokens: [],
        action: '',
        queryString: qrCode.split('?')?.[1] || ''
    };
    if (tokens.length == 1)
    {
        return result;
    }
    let foundAction = false;
    tokens.forEach((t, i) =>
    {
        // If we hit the qr token, the next token is the qr code 
        // and the previous token may be the type or non existent 
        // (in which case the type is Sample)
        if (t === 'qr')
        {
            if (i !== 0)
            {
                result.type = tokens[i - 1] || 'Sample';
            }
            result.code = tokens?.[i + 1] || qrCode;
        }
        // If we hit the action token, this is an action type code.
        // Construct an array of subsequent tokens that can be used to determine what actions to take.
        if (foundAction)
        {
            result.actionTokens.push(t.split('?')[0]);
            result.code = result.actionTokens.join('/');
        }
        if (t === 'action')
        {
            foundAction = true;
            result.type = 'Action';
        }
    });
    // First action token should be the "Action", separate that from the rest of the tokens.
    if (result.actionTokens.length)
    {
        result.action = result.actionTokens[0];
        result.actionTokens = result.actionTokens.slice(1);
    }
    result.code = result.code.split('?')[0];
    return result;
}

module.exports = {
    translateQRCode
};